import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import PersonIcon from '@mui/icons-material/Person';
import PaymentIcon from '@mui/icons-material/Payment';
import { useLanguage } from '../i18n/LanguageContext';

const AuthenticatedLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  const navItems = [
    { label: t.home, icon: <HomeIcon />, path: '/app/dashboard' },
    { label: t.meals, icon: <RestaurantIcon />, path: '/app/meals' },
    { label: t.weight, icon: <MonitorWeightIcon />, path: '/app/weight' },
    { label: t.billing, icon: <PaymentIcon />, path: '/app/billing' },
    { label: t.profile, icon: <PersonIcon />, path: '/app/profile' },
  ];

  const currentTab = navItems.findIndex(item => location.pathname.startsWith(item.path));
  const value = currentTab >= 0 ? currentTab : 0;

  return (
    <Box sx={{ pb: 8 }}>
      <Outlet />
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
        <BottomNavigation
          value={value}
          onChange={(_, newValue) => {
            navigate(navItems[newValue].path);
          }}
          showLabels
        >
          {navItems.map((item) => (
            <BottomNavigationAction
              key={item.path}
              label={item.label}
              icon={item.icon}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </Box>
  );
};

export default AuthenticatedLayout;
